import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import BasicControlGroup from 'components/BasicControlGroup';
import LinkButton from 'components/LinkButton';
import HtmlContentBlock from 'components/HtmlContentBlock';
import Collapsable from 'components/Collapsable';

import './styles.css';

const FirmAboutDescriptionSectionItem = props => {
  const { item, onDelete, onEdit } = props;
  const { Title, Content } = item;

  const hasActions = useMemo(() => onEdit || onDelete, [onEdit, onDelete]);

  const onDeleteFeatureHandler = () => {
    !item.disabled && typeof onDelete === 'function' && onDelete(item);
  };

  const onEditFeatureHandler = () => {
    !item.disabled && typeof onEdit === 'function' && onEdit(item);
  };

  return (
    <li className="firm-about-description-section-item">
      <div className="firm-about-description-section-item__header">
        <h4 className="firm-about-description-section-item__title">{Title}</h4>

        {hasActions && (
          <div className="firm-about-description-section-item__controls">
            <BasicControlGroup>
              {onEdit && (
                <LinkButton text="Edit" controlFunc={onEditFeatureHandler} />
              )}
              {onDelete && (
                <LinkButton
                  text="Delete"
                  controlFunc={onDeleteFeatureHandler}
                />
              )}
            </BasicControlGroup>
          </div>
        )}
      </div>

      {item && (
        <Collapsable
          btnHidden={
            Content.length < 400 && Content.split(/\r\n|\r|\n/).length <= 5
          }
          maskHidden={
            Content.length < 400 && Content.split(/\r\n|\r|\n/).length <= 5
          }
        >
          <HtmlContentBlock content={Content} />
        </Collapsable>
      )}
    </li>
  );
};

FirmAboutDescriptionSectionItem.propTypes = {
  item: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default FirmAboutDescriptionSectionItem;
